'use client'

import { CancelCircle24 } from '@vinted/monochrome-icons'
import { Cell, Icon } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  AdditionalTransactionAction,
  Conversation,
  ConversationActionModal,
  INBOX_URL,
  TransactionSide,
} from '@marketplace-web/messaging/conversation-messaging-data'
import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'

import CancelTransactionModal from '../CancelTransactionModal'
import DropOffPointModal from '../DropOffPointModal'

type Props = {
  conversation?: Conversation
  userId?: number
  visibleModalName: ConversationActionModal | null
  onSetVisibleModalName: (modalName: ConversationActionModal | null) => void
}

const CancelTransactionAction = ({
  conversation,
  userId,
  visibleModalName,
  onSetVisibleModalName,
}: Props) => {
  const translate = useTranslate('conversation.conversation_info')

  const transaction = conversation?.transaction
  const isBuyer = transaction?.userSide === TransactionSide.Buyer

  const handleCancelTransactionClick = () => {
    onSetVisibleModalName(ConversationActionModal.CancelTransaction)
  }

  const handleCancelTransactionSuccess = () => {
    onSetVisibleModalName(null)

    if (!conversation?.id || !userId) return

    navigateToPage(INBOX_URL)
  }

  const handleDropOffPointModalOpen = () => {
    onSetVisibleModalName(ConversationActionModal.DropOffPoint)
  }

  const handleDropOffPointModalClose = () => {
    onSetVisibleModalName(ConversationActionModal.CancelTransaction)
  }

  const handleCancelClick = () => {
    onSetVisibleModalName(null)
  }

  const isCancelActionExist = transaction?.availableActions.includes(
    AdditionalTransactionAction.Cancel,
  )

  if (!isCancelActionExist || !transaction) return null

  return (
    <>
      <Cell
        title={translate('conversation_actions.cancel')}
        prefix={<Icon name={CancelCircle24} color={Icon.Color.Warning} />}
        type={Cell.Type.Navigating}
        onClick={handleCancelTransactionClick}
        testId="conversation-actions-cancel"
      />
      <CancelTransactionModal
        show={visibleModalName === ConversationActionModal.CancelTransaction}
        transactionId={transaction.id}
        isBuyer={isBuyer}
        onSuccess={handleCancelTransactionSuccess}
        onCancel={handleCancelClick}
        onDropOffPointModalOpen={handleDropOffPointModalOpen}
      />
      <DropOffPointModal
        isOpen={visibleModalName === ConversationActionModal.DropOffPoint}
        onClose={handleDropOffPointModalClose}
      />
    </>
  )
}

export default CancelTransactionAction
